module.exports = __webpack_public_path__ + "static/img/xhsz.f933f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example/xhsz.png
// module id = 302o
// module chunks = 1